import { useMemo } from 'react'
import { useAuthContext } from '../../AuthContext.js'

export function usePOVEndDate() {
  const { userinfo, hasPOV } = useAuthContext()

  // Matching POV object
  const pov = useMemo(() => {
    if (!hasPOV) return
    if (!userinfo?.entitlement_info) {
      return {}
    }
    return userinfo.entitlement_info.find(info => info.id.includes('_POV'))
  }, [hasPOV, userinfo])

  return pov
}
